import axios from 'axios'

class SNLog {
  constructor (data) {
    this.id = data.id
    this.sn = data.snHex
    this.operation = data.operation // 操作类型，1-生成，2-烧录，3-激活
    this.nickname = data.nickname // 操作用户昵称
    this.createdAt = data.createdAt
  }
}

/**
 * 获取sn号操作日志
 * @param  {String} username 查询条件，用户名
 * @param  {*Number} pageNo 当前页
 * @param  {*Number} pageSize 每页条数
 * @return {Array}
 */
export const getSNList = async (options) => {
  let params = Object.assign({}, options)
  for (let key in params) {
    if (!params[key]) {
      delete params[key]
    }
  }
  const { data: { records, recordCount } } = await axios.get('v1/sn-operation-logs/pagi', { params })
  const list = records.map(item => new SNLog(item))
  return { list, total: recordCount }
}

/**
 * 获取sn号维护日志
 * @param  {String} username 查询条件，用户名
 * @param  {*Number} pageNo 当前页
 * @param  {*Number} pageSize 每页条数
 * @return {Array}
 */
export const getMaintainList = async (params) => {
  const { data: { records, recordCount } } = await axios.get('v1/sn-after-sales-logs/pagi', { params })
  return { records, recordCount }
}

/**
 * 新增sn号维护日志
 */
export const addMaintain = async (data) => {
  const { data: { code } } = await axios.post('v1/sn-after-sales-logs', { ...data })
  return code
}

/**
 * 更新sn号维护日志
 */
export const editMaintain = async (id, data) => {
  const { data: { code } } = await axios.put(`v1/sn-after-sales-logs/${id}`, { ...data })
  return code
}

/**
 * 获取故障统计
 */
export const getFaultStatistics = async (params) => {
  const { data: { records, recordCount } } = await axios.get('v1/fault-statistics', { params })
  return { records, recordCount }
}

/**
 * 获取故障名列表
 */
export const getFaults = async () => {
  const { data } = await axios.get('v1/faults')
  return data
}

/**
 * 新增故障名
 */
export const addFaults = async (data) => {
  const { data: { code } } = await axios.post('v1/faults', data)
  return code
}

/**
 * 更新故障名
 */
export const updateFaults = async (id, data) => {
  const { data: { code } } = await axios.put(`v1/faults/${id}`, data)
  return code
}

/**
 * 更新故障统计
 */
export const aupdateFaultsStatistics = async (id, data) => {
  const { data: { code } } = await axios.put(`v1/fault-statistics/${id}`, data)
  return code
}
